"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rect = void 0;
/**
 * Represents a rect object
 */

var Rect = /*#__PURE__*/function () {
  /**
   * Creates a new `Rect` object with specified `width` and `height`
   * @param width - `width` of the new rect
   * @param height - `height` of the new rect
   */
  function Rect(width, height) {
    _classCallCheck(this, Rect);

    this.width = 0;
    this.height = 0;
    this.resize(width, height);
  }
  /**
   * Creates a new rect based on extracting specific properties from any provided object
   * @param data - An `IRect` object with `width` and `height` numeric properties
   * @returns A new `Rect` object
   */


  _createClass(Rect, [{
    key: "resize",

    /**
     * Resizes this rect to specified `width` and `height`
     * @param width - a new `width` for the rect
     * @param height - a new `height` for the rect
     */
    value: function resize(width, height) {
      if (width >= 0 && height >= 0) {
        this.width = width;
        this.height = height;
      }
    }
    /**
     * Creates a copy of this rect
     * @returns A new `Rect` object with copied dimensions
     */

  }, {
    key: "copy",
    value: function copy() {
      return new Rect(this.width, this.height);
    }
    /**
     * Returns a string representation of the rect in the format `"[width, height]"`.
     * @returns A string representation of the rect
     */

  }, {
    key: "toString",
    value: function toString() {
      return "[".concat(this.width.toString(), ", ").concat(this.height.toString(), "]");
    }
    /**
     * Returns a JSON representation of the rect
     * @returns An `IRect` object with `width` and `height` numeric properties.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        width: this.width,
        height: this.height
      };
    }
  }], [{
    key: "BuildFromJSON",
    value: function BuildFromJSON(data) {
      return new Rect(data.width, data.height);
    }
  }]);

  return Rect;
}();

exports.Rect = Rect;